import { normalizeOrderStatusLabel } from "../../core/utils/orderStatus";
import type { OrderTitleBarProps } from "../../core/types/tsx/components/order-detail/OrderTitleBar.types";

const badgeStyles: Record<string, string> = {
	Completado: "bg-[#DCFCE7] text-[#008235]",
	"En Proceso": "bg-[#DBEAFE] text-[#008EB9]",
	"En Progreso": "bg-[#DBEAFE] text-[#008EB9]",
	Dialogando: "bg-[#ECD4FB] text-[#8313C8] border border-[#8313C8]",
	"En Espera": "bg-[#DCFCE7] text-[#008235]",
	Soporte: "bg-[#FEFCE8] text-[#894C00]",
	Garantía: "bg-[#FEFCE8] text-[#894C00]",
	Cancelado: "bg-[#FFD4CE] text-[#E93A1F]",
};

export function OrderTitleBar({
	title,
	orderCode,
	statusBadge,
	receiptLabel,
	onDownloadReceipt,
}: OrderTitleBarProps) {
	const normalizedLabel = normalizeOrderStatusLabel(statusBadge);
	const colors = badgeStyles[normalizedLabel] ?? "bg-gray-100 text-gray-600";

	return (
		<header className='flex flex-wrap items-center justify-between gap-4'>
			<div>
				<h1 className='text-2xl font-semibold text-gray-800'>{title}</h1>
				<p className='text-sm text-gray-400'>Pedido #{orderCode}</p>
			</div>
			<div className='flex items-center gap-2'>
				<span
					className={`inline-block rounded-full px-3 py-1 text-xs font-semibold ${colors}`}
				>
					{normalizedLabel}
				</span>
				{receiptLabel && (
					<button
						type='button'
						onClick={onDownloadReceipt}
						className='inline-flex cursor-pointer items-center gap-1 rounded-full border border-secondary bg-secondary px-3 py-1 text-xs font-semibold text-primary hover:bg-blue-100'
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							className='h-3.5 w-3.5'
							fill='none'
							viewBox='0 0 24 24'
							stroke='currentColor'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth={2}
								d='M12 4v10m0 0l-3-3m3 3l3-3M4 20h16'
							/>
						</svg>
						{receiptLabel}
					</button>
				)}
			</div>
		</header>
	);
}

export default OrderTitleBar;
export type { OrderTitleBarProps } from "../../core/types/tsx/components/order-detail/OrderTitleBar.types";
